import axios from "axios";
import { store } from "@/store/store.js";

// Base axios config object
const applicationName = "LDI5"; // For logging purposes

const authApiAxios = axios.create({
  baseURL: process.env.VUE_APP_API_AUTH_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Promise to prevent multiple simultaneous refresh token calls
let refreshTokenPromise = null;

export default {
  async getAuthorizationCodeURL() {
    let resp = await authApiAxios.get('/WebAuthV2/authCodeUrl', {
      params: {
        redirectUri: process.env.VUE_APP_REDIRECT_URI
      }
    });
    return resp.data;
  },

  async exchangeAuthCodeForTokens(code) {
    let body = { code: code };
    let params = {
      grantType: 'authorization_code',
      redirectUri: process.env.VUE_APP_REDIRECT_URI,
      applicationName: applicationName
    };
    // Endpoint requires withCredentials to set HttpOnly cookies, v2 endpoint will set refresh token cookie
    let resp = await authApiAxios.post('/WebAuthV2/token', body, { withCredentials: true, params: params });
    return resp.data;
  },

  // Refresh token is sent via HttpOnly cookie
  async useRefreshToken() {
    // If a refresh is already in progress, return the existing promise
    if (refreshTokenPromise) {
      return refreshTokenPromise;
    }
    
    // Create new refresh promise
    refreshTokenPromise = authApiAxios.get('/WebAuthV2/refresh', { 
      withCredentials: true, 
      params: { applicationName: applicationName } 
    })
      .then((resp) => {
        const data = resp.data;
        // Apply login data to store
        if (data && data.token && data.profile) {
          store.commit("login/applyLoginData", data);
        }
        refreshTokenPromise = null;
        return data;
      })
      .catch((err) => {
        refreshTokenPromise = null;
        throw err;
      });
    
    return refreshTokenPromise;
  },

  async logout() {
    // This will tell the api to clear the refresh_token cookie
    let resp = await authApiAxios.get('/WebAuthV2/logout', { withCredentials: true });
    return resp.data;
  }
};
